import styled, { keyframes } from 'styled-components';
import { Collapse } from 'antd';
import loading0 from '../../images/dolphin/loading/loading_00.png';
import loading1 from '../../images/dolphin/loading/loading_01.png';
import loading2 from '../../images/dolphin/loading/loading_02.png';
import loading3 from '../../images/dolphin/loading/loading_03.png';
import loading4 from '../../images/dolphin/loading/loading_04.png';
import loading5 from '../../images/dolphin/loading/loading_05.png';
import loading6 from '../../images/dolphin/loading/loading_06.png';
import loading7 from '../../images/dolphin/loading/loading_07.png';
import loading8 from '../../images/dolphin/loading/loading_08.png';
import loading9 from '../../images/dolphin/loading/loading_09.png';
import loading10 from '../../images/dolphin/loading/loading_10.png';
import loading11 from '../../images/dolphin/loading/loading_11.png';
import loading12 from '../../images/dolphin/loading/loading_12.png';
import loading13 from '../../images/dolphin/loading/loading_13.png';
import loading14 from '../../images/dolphin/loading/loading_14.png';
import loading15 from '../../images/dolphin/loading/loading_15.png';
import loading16 from '../../images/dolphin/loading/loading_16.png';
import loading17 from '../../images/dolphin/loading/loading_17.png';
import loading18 from '../../images/dolphin/loading/loading_18.png';
import loading19 from '../../images/dolphin/loading/loading_19.png';
import loading20 from '../../images/dolphin/loading/loading_20.png';
import loading21 from '../../images/dolphin/loading/loading_21.png';
import loading22 from '../../images/dolphin/loading/loading_22.png';
import loading23 from '../../images/dolphin/loading/loading_23.png';
import loading24 from '../../images/dolphin/loading/loading_24.png';

import playIcon from '../../static/dolphin/other/hove2@2x.png';

const { Panel } = Collapse;

const loadingPercent = 100 / 24;
const loadingFrames = keyframes`
  0%  {background: url(${loading0}) center top no-repeat;}
  ${loadingPercent * 1}%  {background: url(${loading1}) center top no-repeat;}
  ${loadingPercent * 1}%  {background: url(${loading2}) center top no-repeat;}
  ${loadingPercent * 1}% {background: url(${loading3}) center top no-repeat;}
  ${loadingPercent * 1}% {background: url(${loading4}) center top no-repeat;}
  ${loadingPercent * 1}% {background: url(${loading5}) center top no-repeat;}
  ${loadingPercent * 1}% {background: url(${loading6}) center top no-repeat;}
  ${loadingPercent * 1}% {background: url(${loading7}) center top no-repeat;}
  ${loadingPercent * 1}% {background: url(${loading8}) center top no-repeat;}
  ${loadingPercent * 1}% {background: url(${loading9}) center top no-repeat;}
  ${loadingPercent * 1}% {background: url(${loading10}) center top no-repeat;}
  ${loadingPercent * 1}% {background: url(${loading11}) center top no-repeat;}
  ${loadingPercent * 1}% {background: url(${loading13}) center top no-repeat;}
  ${loadingPercent * 1}% {background: url(${loading12}) center top no-repeat;}
  ${loadingPercent * 1}% {background: url(${loading14}) center top no-repeat;}
  ${loadingPercent * 1}% {background: url(${loading15}) center top no-repeat;}
  ${loadingPercent * 1}% {background: url(${loading16}) center top no-repeat;}
  ${loadingPercent * 1}% {background: url(${loading17}) center top no-repeat;}
  ${loadingPercent * 1}% {background: url(${loading18}) center top no-repeat;}
  ${loadingPercent * 1}% {background: url(${loading19}) center top no-repeat;}
  ${loadingPercent * 1}% {background: url(${loading20}) center top no-repeat;}
  ${loadingPercent * 1}% {background: url(${loading21}) center top no-repeat;}
  ${loadingPercent * 1}% {background: url(${loading22}) center top no-repeat;}
  ${loadingPercent * 1}% {background: url(${loading23}) center top no-repeat;}
  100% {background: url(${loading24}) center top no-repeat;}
`;

export const StyledRecorderContainer = styled.div`
  background: rgba(33, 33, 103, 0.5);
  box-sizing: border-box;
  padding: 10px 40px;
  border-radius: 6px;
  width: 70%;
  height: 65%;
  position: relative;
  top: 35px;

  .loading {
    width: 467px;
    height: 352px;
    animation-fill-mode: both;
    animation-iteration-count: infinite;
    animation-name: ${loadingFrames};
    animation-duration: 1000ms;
    background-size: 80%;
    margin: 0 auto;
    position: relative;
    transform: scale(0.5);
    span {
      color: #9696f5;
      position: absolute;
      bottom: -40px;
      width: 100%;
      text-align: center;
      font-size: 30px;
      left: 0;
    }
  }

  .operate-area {
    margin: 0 auto;
    height: 100%;
    position: relative;
  }

  .recorder {
    text-align: center;
  }

  .statistics {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 68.75%;
    margin: 80px auto 0;

    &.statistics-show-enter {
      opacity: 0;
      transform: translate3d(0, 100%, 0);
    }
    &.statistics-show-enter-active {
      transition: all 0.55s;
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }

    &.statistics-show-exit {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
    &.statistics-show-exit-active {
      transition: all 0.55s;
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }
  }

  .go-to-home {
    width: 96px;
    height: 38px;
    background: rgba(219, 80, 224, 1)
      linear-gradient(
        360deg,
        rgba(250, 74, 111, 1) 0%,
        rgba(239, 83, 149, 1) 31%,
        rgba(222, 77, 203, 1) 76%,
        rgba(206, 76, 230, 1) 100%
      );
    box-shadow: 0px 15px 20px 0px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    text-align: center;
    line-height: 38px;
    position: absolute;
    right: 0;
    font-size: 14px;
    top: -180px;
    cursor: pointer;

    &:hover {
      color: rgba(255, 255, 255, 0.5);
    }
  }

  .title {
    position: absolute;
    width: 100%;
    top: -130px;
    text-align: center;
    font-size: 36px;

    img {
      width: 50%;
    }
  }
`;

export const StyledSubjectCollapse = styled(Collapse)`
  background: transparent !important;
  color: #fff;
`;

export const StyledSubjectCollapsePanel = styled(Panel)`
  margin: 20px 0;
  border: none !important;

  &.fade-enter {
    opacity: 0;
  }
  &.fade-enter-active {
    transition: all 0.3s;
    opacity: 1;
  }

  &.fade-exit {
    opacity: 1;
  }
  &.fade-exit-active {
    transition: all 0.3s;
    opacity: 0;
  }

  .ant-collapse-header {
    border: 1px dashed #676767;
    font-size: 18px;
    font-weight: bold;
    background: transparent;
    color: #ffffff !important;
    border-radius: 6px !important;

    &:hover {
      background: rgba(255, 255, 255, 0.4);
      color: #ffffff;
    }

    &[aria-expanded='true'] {
      background-image: linear-gradient(#fa4a6f, #ef5395, #de4dcb, #ce4ce6);
      color: #ffffff;
    }
  }

  .ant-collapse-content-box {
    color: #9e9eff;
    font-size: 16px;
  }
`;

export const StyledTalRecorderContainer = styled.div`
  .count-down {
    #canvas {
      position: absolute;
      bottom: calc(15% - 60px);
      transform: translate(-300px, 0);
      left: 50%;
      right: 0;
      z-index: 1;
    }
  }

  .count {
    margin-top: 160px;
    &.count-down-enter {
      opacity: 0;
      font-size: 20px;
    }
    &.count-down-enter-active {
      transition: all 1s;
      opacity: 1;
      font-size: 50px;
    }

    &.count-down-exit {
      opacity: 1;
      font-size: 50px;
    }
    &.count-down-exit-active {
      transition: all 1s;
      opacity: 0;
      font-size: 80px;
    }
  }

  .operation-container {
    width: 80px;
    height: 80px;
    text-align: center;
    margin: 20px auto 0;
    position: absolute;
    bottom: 15%;
    left: 50%;
    transform: translate3d(-40px, 0, 0);
    left: 50%;
    z-index: 2;

    .start-stop-button {
      width: 100%;
      height: 100%;
      background: rgba(219, 80, 224, 1)
        linear-gradient(
          360deg,
          rgba(250, 74, 111, 1) 0%,
          rgba(239, 83, 149, 1) 31%,
          rgba(222, 77, 203, 1) 76%,
          rgba(206, 76, 230, 1) 100%
        );
      box-shadow: 0px 15px 20px 0px rgba(0, 0, 0, 0.1);
      border-radius: 50%;
      cursor: pointer;
      text-align: center;
      line-height: 80px;
      font-size: 40px;
      z-index: 2;
      color: #fff;
      border: none;

      &:hover {
        color: rgba(255, 255, 255, 0.5);
      }
    }

    .stop-text {
      font-size: 14px;
      height: 20px;
      line-height: 20px;
    }
    .recorde-time {
      color: #9e9eff;
      font-size: 14px;
      position: absolute;
      bottom: -40px;
      left: 2px;
      width: 100%;
    }
  }

  .bottom-process {
    position: absolute;
    bottom: 20px;
    left: 70px;
    width: 40%;

    .process {
      position: relative;

      &.process-show-enter {
        opacity: 0;
        transform: translate3d(-100%, 0, 0);
      }
      &.process-show-enter-active {
        transition: all 0.55s;
        opacity: 1;
        transform: translate3d(0, 0, 0);
      }

      &.process-show-exit {
        opacity: 1;
        transform: translate3d(0, 0, 0);
      }
      &.process-show-exit-active {
        transition: all 0.55s;
        opacity: 0;
        transform: translate3d(100%, 0, 0);
      }

      .play-icon {
        width: 75px;
        height: 75px;
        display: inline-block;
        font-style: normal;
        background: url(${playIcon}) no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
        position: absolute;
        left: -60px;
        top: -18px;
      }

      .duration-text {
        color: #5757a5;
        font-size: 12px;
        position: absolute;
        right: -35px;
        top: 0px;
      }

      .ant-slider {
        .ant-slider-rail {
          background-color: #5757a5;
        }
        .ant-slider-track {
          background-color: #db50e0;
        }
        .ant-slider-handle {
          background-color: #fff;
          border: solid 5px #db50e0;
        }
      }
    }
  }

  .go-to-result {
    width: 140px;
    height: 38px;
    background: rgba(219, 80, 224, 1)
      linear-gradient(
        360deg,
        rgba(250, 74, 111, 1) 0%,
        rgba(239, 83, 149, 1) 31%,
        rgba(222, 77, 203, 1) 76%,
        rgba(206, 76, 230, 1) 100%
      );
    box-shadow: 0px 15px 20px 0px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    line-height: 38px;
    position: absolute;
    bottom: 20px;
    right: 0;
    cursor: pointer;
    a {
      color: #fff;
    }
    &:hover {
      a {
        color: rgba(255, 255, 255, 0.5);
      }
    }
  }
`;
